module.exports = __webpack_public_path__ + "static/img/banner-1-01-01.0b597ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-1-01-01.png
// module id = /xXI
// module chunks = 1